<section class="bcx-features-section py-5">
  <div class="container-fluid px-3 px-md-4 px-lg-5">

    <div class="row mb-4 mb-lg-5">
      <div class="col-12 col-lg-7">
        <p class="text-uppercase text-danger fw-bold text-xs mb-2" style="letter-spacing: 0.06em;">
          What you get
        </p>
        <h2 class="fw-bold display-6 mb-0">
          Built for every system <span class="text-danger">you run.</span>
        </h2>
      </div>
    </div>

    <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-4">
      <div class="col" v-for="feature in features" :key="feature.key">
        <div class="card bcx-card h-100">
          <div class="card-body p-4">
            <div class="bcx-icon-chip mb-3">
              <i :class="feature.icon"></i>
            </div>
            <h3 class="card-title h5 fw-bold mb-2">{{ feature.title }}</h3>
            <p class="card-text text-secondary text-sm mb-3">{{ feature.description }}</p>
            <router-link to="/login" class="bcx-link-explore">
              Explore more
              <i class="bi bi-arrow-right"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>
